module.exports = __webpack_public_path__ + "static/media/whiteArrow.f1c7432c.svg";